import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect } from 'react';
var DEFAULT_MOBILE = false;
// const DEFAULT_MOBILE = '768px';
var MOBILE_CLASSNAME = 'sendbird--mobile-mode';
var MediaQueryContext = /*#__PURE__*/React__default.createContext({
  breakpoint: DEFAULT_MOBILE,
  isMobile: false
});
var addClassNameToBody = function addClassNameToBody() {
  try {
    var body = document.querySelector('body');
    body === null || body === void 0 ? void 0 : body.classList.add(MOBILE_CLASSNAME);
  } catch (_unused) {
    // noop
  }
};
var removeClassNameFromBody = function removeClassNameFromBody() {
  try {
    var body = document.querySelector('body');
    body === null || body === void 0 ? void 0 : body.classList.remove(MOBILE_CLASSNAME);
  } catch (_unused2) {
    // noop
  }
};
var MediaQueryProvider = function MediaQueryProvider(props) {
  var children = props.children,
    logger = props.logger;
  var breakpoint = (props === null || props === void 0 ? void 0 : props.breakpoint) || false;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  useEffect(function () {
    var _logger$info6;
    var updateSize = function updateSize() {
      if (typeof breakpoint === 'boolean') {
        setIsMobile(breakpoint);
        if (breakpoint) {
          var _logger$info;
          logger === null || logger === void 0 ? void 0 : (_logger$info = logger.info) === null || _logger$info === void 0 ? void 0 : _logger$info.call(logger, 'MediaQueryProvider: isMobile: true');
          addClassNameToBody();
        } else {
          var _logger$info2;
          logger === null || logger === void 0 ? void 0 : (_logger$info2 = logger.info) === null || _logger$info2 === void 0 ? void 0 : _logger$info2.call(logger, 'MediaQueryProvider: isMobile: false');
          removeClassNameFromBody();
        }
      } else {
        var _logger$info3;
        var mq = window.matchMedia("(max-width: ".concat(breakpoint, ")"));
        logger === null || logger === void 0 ? void 0 : (_logger$info3 = logger.info) === null || _logger$info3 === void 0 ? void 0 : _logger$info3.call(logger, "MediaQueryProvider: Screensize updated to ".concat(breakpoint));
        if (mq.matches) {
          var _logger$info4;
          setIsMobile(true);
          addClassNameToBody();
          logger === null || logger === void 0 ? void 0 : (_logger$info4 = logger.info) === null || _logger$info4 === void 0 ? void 0 : _logger$info4.call(logger, 'MediaQueryProvider: isMobile: true');
        } else {
          var _logger$info5;
          setIsMobile(false);
          removeClassNameFromBody();
          logger === null || logger === void 0 ? void 0 : (_logger$info5 = logger.info) === null || _logger$info5 === void 0 ? void 0 : _logger$info5.call(logger, 'MediaQueryProvider: isMobile: false');
        }
      }
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    logger === null || logger === void 0 ? void 0 : (_logger$info6 = logger.info) === null || _logger$info6 === void 0 ? void 0 : _logger$info6.call(logger, 'MediaQueryProvider: addEventListener', {
      updateSize: updateSize
    });
    return function () {
      var _logger$info7;
      window.removeEventListener('resize', updateSize);
      logger === null || logger === void 0 ? void 0 : (_logger$info7 = logger.info) === null || _logger$info7 === void 0 ? void 0 : _logger$info7.call(logger, 'MediaQueryProvider: removeEventListener', {
        updateSize: updateSize
      });
    };
  }, [breakpoint]);
  return /*#__PURE__*/React__default.createElement(MediaQueryContext.Provider, {
    value: {
      breakpoint: breakpoint,
      isMobile: isMobile
    }
  }, children);
};
var useMediaQueryContext = function useMediaQueryContext() {
  return React__default.useContext(MediaQueryContext);
};
export { MediaQueryProvider as M, useMediaQueryContext as u };